import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'styleSanitizer',
})
export class StyleSanitizerPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer){

  }

  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/style-sanitizer/style-sanitizer.ts